<template>
  <form class="form-group" @submit.prevent="handleSubmit" ref="formRef">
    <div class="group-rows">
      <div class="group-columns">
        <label for="vehicleId">Véhicule *</label>
        <select v-model="localData.vehicleId" id="vehicleId" required>
          <option value="">-- Sélectionner un véhicule --</option>
          <option v-for="vehicle in vehicles" :key="vehicle.id" :value="vehicle.id">
            {{ vehicle.model }} - {{ vehicle.noImmat }}
          </option>
        </select>
      </div>
      <!-- Ajout du select pour le chauffeur -->
      <div class="group-columns flex-auto">
        <label for="driverId">Chauffeur *</label>
        <select v-model="localData.driverId" id="driverId" required>
          <option value="">-- Sélectionner un chauffeur --</option>
          <option v-for="driver in drivers" :key="driver.id" :value="driver.id">
            {{ driver.firstName }} {{ driver.lastName }}
          </option>
        </select>
      </div>
    </div>
      <label for="addressIdToStart">Départ *</label>
      <select v-model="localData.addressIdToStart" id="addressIdToStart" required>
        <option value="">-- Sélectionner une adresse --</option>
        <option v-for="address in addresses" :key="address.id" :value="address.id">
          {{ address.name }} ({{ address.city?.name }})
        </option>
      </select>
      <label for="addressIdToEnd">Arrivée *</label>
      <select v-model="localData.addressIdToEnd" id="addressIdToEnd" required>
        <option value="">-- Sélectionner une adresse --</option>
        <option v-for="address in addresses" :key="address.id" :value="address.id">
          {{ address.name }} ({{ address.city?.name }})
        </option>
      </select>
      <div class="group-rows">
        <div class="group-columns">
          <label for="timeToStart">Départ *</label>
          <input v-model="localData.timeToStart" type="datetime-local" id="timeToStart" required />
        </div>
        <div class="group-columns">
          <label for="timeToEnd">Arrivée *</label>
          <input v-model="localData.timeToEnd" type="datetime-local" id="timeToEnd" required />
        </div>
      </div>
      <label for="price">Prix (FCFA) *</label>
      <input v-model.number="localData.price" type="number" id="price" step="1" min="0" required />
      <div v-if="error" class="error-message">{{ error }}</div>
  </form>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  formData: { type: Object, default: () => ({ vehicleId: '', driverId: '', addressIdToStart: '', addressIdToEnd: '', timeToStart: '', timeToEnd: '', price: 0 }) },
  vehicles: { type: Array, default: () => [] },
  addresses: { type: Array, default: () => [] },
  drivers: { type: Array, default: () => [] }
})

const emit = defineEmits(['submit', 'cancel'])

const formRef = ref(null)
const error = ref('')

const localData = ref({
  driverId: props.formData?.driverId || '',
  vehicleId: props.formData?.vehicleId || '',
  addressIdToStart: props.formData?.addressIdToStart || '',
  addressIdToEnd: props.formData?.addressIdToEnd || '',
  timeToStart: props.formData?.timeToStart || '',
  timeToEnd: props.formData?.timeToEnd || '',
  price: props.formData?.price || 0
})

watch(() => props.formData, (newFormData) => {
  if (newFormData) {
    localData.value = {
      driverId: newFormData.driverId || '',
      vehicleId: newFormData.vehicleId || '',
      addressIdToStart: newFormData.addressIdToStart || '',
      addressIdToEnd: newFormData.addressIdToEnd || '',
      timeToStart: newFormData.timeToStart || '',
      timeToEnd: newFormData.timeToEnd || '',
      price: newFormData.price || 0
    }
  }
}, { deep: true })

const handleSubmit = () => {
  error.value = ''

  if (!formRef.value?.checkValidity()) {
    formRef.value?.reportValidity()
    return
  }

  emit('submit', { ...localData.value })
}

defineExpose({ handleSubmit })
</script>
